import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useClickAway, useToggle } from 'react-use';

import { Fade } from '@mssgme/ui';

import ToggleButton from './ToggleButton';
import { AssignOption } from '../../Conversations';
import styles from './AssignTo.scss';

AssignTo.propTypes = {
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

export default function AssignTo({ options, placeholder, value, onChange }) {
    const rootRef = useRef();
    const [isOpen, toggle] = useToggle();
    const selectedOption = options.find((o) => o.value === value);

    useClickAway(rootRef, () => {
        toggle(false);
    });

    const handleSelect = (v) => {
        onChange(v);
        toggle(false);
    };

    return (
        <div className={styles.root} ref={rootRef}>
            <ToggleButton isPressed={isOpen} onToggle={toggle}>
                {selectedOption ? selectedOption.label : placeholder}
            </ToggleButton>
            <Fade in={isOpen}>
                <div className={styles.dropdown}>
                    {options.map((option, key) => (
                        <AssignOption
                            as="a"
                            href="#"
                            key={key}
                            isSelected={option.value === value}
                            onSelect={handleSelect}
                            {...option}
                        />
                    ))}
                </div>
            </Fade>
        </div>
    );
}
